import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { SettingsCard as DroneSettingsCard } from "@/pages/AdminDronePage";
import { DeedFeesCard } from "@/components/DeedFeesCard";
import { BannerPanel } from "@/components/admin/BannerPanel";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { toast } from "sonner";

const TRIGGERS = { LOGIN: "Kullanıcı sisteme girdiğinde", DASHBOARD: "Panel (ana sayfa) açıldığında", NAVIGATION: "Her sayfa değişiminde" };

const AdSettingsCard = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/ad-settings").then((r) => setS(r.data)); }, []);
  if (!s) return null;
  const save = async () => {
    try { setS((await api.put("/admin/ad-settings", { max_per_day: Number(s.max_per_day), triggers: s.triggers })).data); toast.success("Reklam ayarları kaydedildi"); }
    catch (x) { toast.error(formatApiError(x.response?.data?.detail)); }
  };
  return (
    <Card className="p-5 space-y-4" data-testid="ad-settings-card">
      <div className="font-semibold">Pop-up reklam gösterimi</div>
      <div className="max-w-xs"><Label>Bir kullanıcıya günde en fazla kaç kez gösterilsin?</Label><Input data-testid="ad-max-per-day" type="number" min="0" max="20" value={s.max_per_day} onChange={(e) => setS({ ...s, max_per_day: e.target.value })} /></div>
      <div className="space-y-2">
        <Label>Ne zaman gösterilsin?</Label>
        {Object.entries(TRIGGERS).map(([k, l]) => (
          <label key={k} className="flex items-center gap-2 text-sm">
            <Checkbox data-testid={`ad-trigger-${k}`} checked={s.triggers.includes(k)} onCheckedChange={(v) => setS({ ...s, triggers: v ? [...s.triggers, k] : s.triggers.filter((x) => x !== k) })} />{l}
          </label>
        ))}
      </div>
      <div className="flex justify-end"><Button data-testid="ad-settings-save" onClick={save}>Kaydet</Button></div>
    </Card>
  );
};

export default function AdminSettingsPage() {
  const { hasPerm } = useAuth();
  const tabs = [
    hasPerm("CAMPAIGNS_MANAGE") && ["ads", "Reklam gösterimi", <AdSettingsCard />],
    hasPerm("CAMPAIGNS_MANAGE") && ["banner", "Üst reklam bandı", <BannerPanel />],
    hasPerm("PACKAGES_MANAGE") && ["deed", "Tapu masrafları", <DeedFeesCard />],
    hasPerm("PACKAGES_MANAGE") && ["drone", "Drone çekim", <DroneSettingsCard />],
  ].filter(Boolean);
  return (
    <div className="space-y-6 max-w-4xl" data-testid="admin-settings-page">
      <div>
        <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold mb-1">Süper Admin</div>
        <h1 className="text-4xl font-extrabold tracking-tight text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>Ayarlar</h1>
        <p className="text-slate-500 mt-1">Paket özellikleri ve limitleri Paketler sayfasından; kampanyalar ve pop-up reklamlar Kampanyalar sayfasından yönetilir.</p>
      </div>
      {tabs.length === 0 ? <Card className="p-8 text-sm text-slate-500">Bu ayarları değiştirme yetkiniz yok.</Card> : (
        <Tabs defaultValue={tabs[0][0]}>
          <TabsList>{tabs.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`admin-settings-tab-${k}`}>{l}</TabsTrigger>)}</TabsList>
          {tabs.map(([k, , el]) => <TabsContent key={k} value={k} className="mt-4">{el}</TabsContent>)}
        </Tabs>
      )}
    </div>
  );
}
